import { TileIndex } from "../../types";

export const CHAIN_REACTION: TileIndex[][] = [


  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 0, 0, 0, 0, 0, 25, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 1],
  [1, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 1],
  [1, 0, 0, 0, 0, 0, 0, 23, 30, 23, 23, 23, 23, 30, 21, 0, 0, 1],
  [1, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 21, 0, 0, 1],
  [1, 0, 0, 12, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 21, 0, 0, 1],
  [1, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 21, 0, 0, 1],
  [1, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 30, 0, 0, 1],
  [1, 0, 0, 0, 0, 32, 0, 0, 0, 22, 22, 22, 22, 22, 22, 0, 0, 1],
  [1, 0, 0, 0, 0, 25, 18, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 26, 26, 26, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 2, 2, 26, 0, 0, 0, 27, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 15, 2, 26, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
]